// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a3451a54","453":"cd29273e","455":"36c9ad87"}[chunkId] + ".chunk.js";
};